<div class="form-group" [ngClass]="{'row': horizontal}">
    <label for="InputNombre" [ngClass]="{'col-sm-4 col-form-label text-right': horizontal}" *ngIf="label">{{label}}</label>
    <div [ngClass]="{'col-sm-8': horizontal}">
        <ng-container [ngTemplateOutlet]="input" *ngIf="!iconPrepend && !iconAppend"></ng-container>
        <div class="input-group mb-3" [ngClass]="size == '' ? '' : 'input-group-'+ size"
            *ngIf="iconPrepend || iconAppend">
            <div class="input-group-prepend" *ngIf="iconPrepend">
                <span class="input-group-text">
                    <i class="fas {{iconPrepend}}"></i>
                </span>
            </div>
            <ng-container [ngTemplateOutlet]="input"></ng-container>
            <div class="input-group-append" *ngIf="iconAppend">
                <span class="input-group-text">
                    <i class="fas {{iconAppend}}"></i>
                </span>
            </div>
        </div>
    </div>
</div>

<ng-template #input>
    <input [type]="type" [id]="idForm" [name]="idForm" [formControl]="control" [placeholder]="placeholder"
        class="form-control" [ngClass]="size == '' ? '' : 'form-control-'+ size"
        [autocomplete]="autocomplete ? 'on' : 'off'" [tabindex]="tabIndex" [maxlength]="maxLength"
        [readOnly]="readOnly">
</ng-template>